import React, { useState } from "react";
import moment from "moment";
import { DatePicker } from "antd";
import AppIcon from "./AppIcon";
import { AppFieldWithLabelAndError } from "./AppTypography";

const AppDatePicker = ({
  label = "",
  value,
  onChange,
  placeholder = "DD-MM-YYYY",
  disabled = false,
  outputFormat = "YYYY-MM-DD", // Format for the onChange callback output
  required = false,
  mandatory = false,
  error,
  ...restProps
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="w-full">
      <AppFieldWithLabelAndError
        label={label}
        required={required || mandatory}
        error={error}
      >
        <div className="relative">
          <DatePicker
            value={value ? moment(value) : null}
            onChange={onChange}
            format="DD-MM-YYYY"
            disabled={disabled}
            placeholder={placeholder}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className={`app-date-picker-custom ${
              isFocused ? "app-date-picker-focused" : ""
            }`}
            suffixIcon={<AppIcon name="calendar" />}
            {...restProps}
          />
        </div>
      </AppFieldWithLabelAndError>
    </div>
  );
};

export default AppDatePicker;
